import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio2To132(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMediaObjectRatio2To132"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 7h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2M3 9a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4zm17.965-1a1 1 0 0 1 1-1h6.057a1 1 0 1 1 0 2h-6.057a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h6.057a1 1 0 1 1 0 2h-6.057a1 1 0 0 1-1-1m1-5a1 1 0 1 0 0 2h2.869a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h2.869a1 1 0 1 1 0 2h-2.87a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio2To132);
